"use client";

import React from "react";
import { MappedFaqItem } from "@/services/faq/types";
import { Accordion } from "@ama-pt/agora-design-system";
import { convertLexicalWithInternalLinks } from "@/lib/lexical";

interface FaqAccordionProps {
  faqs: MappedFaqItem[];
  category: string;
}

export default function FaqAccordion({ faqs, category }: FaqAccordionProps) {
  return (
    <div className="space-y-4 divide-y divide-gray-200">
      {faqs.map((faq, index) => (
        <div key={`${category}-${index}`}>
          <Accordion headingTitle={faq?.question}>
            <div>
              <div
                dangerouslySetInnerHTML={{ __html: convertLexicalWithInternalLinks( faq?.answer as any ) }}
                className="text-m-regular text-neutral-900 py-8 prose prose-ul:my-0 marker:text-neutral-900"
              />
            </div>
          </Accordion>
        </div>
      ))}
    </div>
  );
}
